document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('[data-mobile-menu]');
  const open = document.querySelector('[data-menu-open]');
  const close = document.querySelector('[data-menu-close]');
  const setMenu = (visible) => {
    if (!menu) return;
    menu.hidden = !visible;
    document.body.classList.toggle('menu-open', visible);
  };
  open?.addEventListener('click', () => setMenu(true));
  close?.addEventListener('click', () => setMenu(false));
  menu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false)));

  document.querySelectorAll('[data-product-card]').forEach((card) => {
    const images = [...card.querySelectorAll('.product-image')];
    card.querySelectorAll('[data-image-index]').forEach((button) => {
      button.addEventListener('click', () => {
        const index = Number(button.dataset.imageIndex || 0);
        images.forEach((image, imageIndex) => image.classList.toggle('active', imageIndex === index));
        card.querySelectorAll('[data-image-index]').forEach((tab) => tab.classList.toggle('active', tab === button));
      });
    });
  });
});
